import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const InnerServices = createApi({
	reducerPath: "InnerServices",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
	}),
	endpoints: (builder) => {
		return {
			getServices: builder.query({
				query: () => {
					return {
						url: "services",
						method: "GET",
					};
				},
			}),
			getServiceById: builder.query({
				query: (paramId) => {
					return {
						url: `categories/products/${paramId}`,
						method: "GET",
					};
				},
			}),
			getInnerServiceById: builder.query({
				query: (paramId) => {
					return {
						url: `/services/${paramId}`,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const {
	useGetServicesQuery,
	useGetServiceByIdQuery,
	useGetInnerServiceByIdQuery,
} = InnerServices;
export default InnerServices;
